module.exports = __webpack_public_path__ + "static/media/7C.d2e8a6b9.svg";